import { create } from "zustand"
import type { TDeleteCategory, TObjectCategoryDrawerStore } from "types/configuration.type"

// Delete category
export const useDeleteCategoryStore = create<TDeleteCategory>((set) => ({
	isDeleteCategoryModalOpen: false,
	deleteCategoryData: {
		categoryName: "",
		deletionWarningText: "",
		categoryId: undefined,
	},

	setDeleteCategoryModalClose: () => set(() => ({ isDeleteCategoryModalOpen: false })),
	setDeleteCategoryModalOpen: () => set(() => ({ isDeleteCategoryModalOpen: true })),

	setDeleteCategoryData: ({ categoryName, deletionWarningText, categoryId }) =>
		set(() => ({ deleteCategoryData: { categoryName, deletionWarningText, categoryId } })),
}))

// Category object drawer
export const useObjectCategoryDrawerStore = create<TObjectCategoryDrawerStore>((set) => ({
	objectCategoryStore: {
		name: "",
		id: null,
		type: "",
		label: "",
		inModelTrain: null,
		inProcessingResult: null,
		objectCount: null,
		dimensions: {},
		modelNumbers: [],
		recipes: [],
	},
	setObjectCategory: (category) =>
		set((state) => ({
			objectCategoryStore: category,
			modelNumberToId: {},
			// "New" tags belong to the object they were linked to; opening another object drops them.
			newModelNumbers: category.id === state.objectCategoryStore.id ? state.newModelNumbers : [],
		})),
	newModelNumbers: [],
	markNewModelNumbers: (names) => set((state) => ({ newModelNumbers: [...state.newModelNumbers, ...names] })),
	modelNumberToId: {},
	setModelNumberToId: (map) => set(() => ({ modelNumberToId: map })),
	isDrawerOpen: false,
	triggerDrawer: () =>
		set((state) => ({
			isDrawerOpen: !state.isDrawerOpen,
			// "New" tags last for one viewing of the drawer.
			newModelNumbers: state.isDrawerOpen ? [] : state.newModelNumbers,
		})),
}))
